
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.82 4.813v1.085H1.367c.026.485.097.915.211 1.29.115.375.287.695.516.96.234.26.534.454.898.579.37.125.878.187 1.524.187H7.82V10H4.484a8.19 8.19 0 01-1.328-.094 3.926 3.926 0 01-1.015-.304 2.901 2.901 0 01-.86-.633 3.863 3.863 0 01-.648-.946A4.697 4.697 0 01.258 6.86a7.435 7.435 0 01-.125-1.406c0-.823.08-1.502.242-2.039.161-.542.432-1.02.813-1.437a3.22 3.22 0 011.367-.907C3.085.888 3.773.797 4.617.797H7.82v1.086H4.61c-.516 0-.936.028-1.258.086a2.311 2.311 0 00-.797.281 2.025 2.025 0 00-.586.54 2.733 2.733 0 00-.407.866 5.26 5.26 0 00-.187 1.156H7.82z","fill":"currentColor"}})])
          )
        }
      }
    